import React from 'react'
import {Link} from "react-router-dom"
import MenuBar from '../../assets/Images/mobilemenu.svg';
import MenuIcon from '@material-ui/icons/Menu';
import LargeMenuBar from '../../assets/Images/hamburgermenu.svg';
import OrangeCircle from '../../assets/Images/Oval.svg'

const NavBar = ({toggle}) => {
    return (
        <>
        <header className="lg:px-20 px-6 py-6 flex flex-wrap items-center bg-gray-900 z-0">
          <div className="flex-1 flex lg:justify-between justify-evenly items-center">
            <Link to="/" >
              <span className="text-4xl font-semibold font-mono text-white uppercase">
                FASHO
              </span>
            </Link>
            {/* <img src={LargeMenuBar} alt="menu" className="self-center cursor-pointer"/> */}
            <div className="flex items-center cursor-pointer">
              <div className="px-4 cursor-pointer" onClick={() => toggle(false)}>
                {/* <MenuIcon fontSize={'large'} fill="#FFFFFF" /> */}
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" viewBox="0 0 20 20" fill="#FFFFFF">
                  <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
              </div>
                    {/* <Link to={`/`}>
                      <img
                        className="rounded-full h-12 w-12 flex"
                        src={OrangeCircle}
                        alt={"Well hello"}
                      />
                    </Link> */}
              </div>
           
          </div>
        </header>
        {/* <Nav>
          <NavLink to='/'>FASHO</NavLink>
          <NavIcon onClick={toggle}>
            <p>Menu</p>
            <Bars />
          </NavIcon>
        </Nav> */}
      </>
    )
}

export default NavBar